import React from 'react';
import { CTAButton } from './CTAButton';
import { HeroCarousel } from './HeroCarousel';
import { CheckCircleIcon, SparklesIcon, ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-white" data-id="element-324">
      <div className="pt-8 pb-12 md:pt-20 md:pb-24 px-4" data-id="element-325">
        <div className="max-w-[1080px] mx-auto" data-id="element-326">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-16 items-center" data-id="element-327">
            {/* ===== DESKTOP LEFT COLUMN (hidden on mobile) ===== */}
            <div className="hidden md:block text-left" data-id="element-328">
              <p className="font-body text-sm uppercase tracking-widest text-pink-dark font-semibold mb-4" data-id="element-329">
                Para mujeres que quieren crear su propio bikini sin depender de
                nadie
              </p>

              <h1 className="font-heading font-bold text-[2.6rem] lg:text-5xl text-dark-gray leading-[1.15] mb-5" data-id="element-330">
                Creá tu propio bikini al crochet en 24 horas{' '}
                <span className="text-pink-dark" data-id="element-331">
                  (aunque nunca hayas tejido antes)
                </span>
              </h1>

              <p className="font-body text-lg text-medium-gray leading-relaxed mb-8 max-w-[480px]" data-id="element-332">
                De no saber por dónde empezar a tener un bikini hecho por ti,
                listo para usar este verano… sin frustración y con resultados
                que parecen comprados.
              </p>

              <div className="flex flex-col items-start gap-2.5 max-w-[400px] mb-8" data-id="element-333">
                {['Guía paso a paso desde cero', 'Patrones fáciles y claros', 'Acceso inmediato por email', 'Resultados en 24 horas'].map(text => <div key={text} className="flex items-center gap-2.5" data-id="element-334">
                    <CheckCircleIcon className="w-5 h-5 text-pink-dark flex-shrink-0" data-id="element-335" />
                    <span className="font-body text-dark-gray text-base font-medium" data-id="element-336">
                      {text}
                    </span>
                  </div>)}
                <div className="flex items-center gap-2.5" data-id="element-337">
                  <SparklesIcon className="w-5 h-5 text-pink-dark flex-shrink-0" data-id="element-338" />
                  <span className="font-body text-dark-gray text-base font-bold" data-id="element-339">
                    +5 bonos GRATIS incluidos
                  </span>
                </div>
              </div>

              <div className="mb-6 space-y-1" data-id="element-340">
                <p className="font-body text-sm text-medium-gray" data-id="element-341">
                  Ebook: <span className="line-through" data-id="element-342">$19,99</span> · Bonos:{' '}
                  <span className="line-through" data-id="element-343">$47</span>{' '}
                  <span className="text-pink-dark font-semibold" data-id="element-344">GRATIS</span>
                </p>
                <p className="font-body text-medium-gray text-base" data-id="element-345">
                  Total <span className="line-through" data-id="element-346">$66,99</span> —{' '}
                  <span className="font-bold text-dark-gray" data-id="element-347">80% OFF</span> —
                  hoy todo por
                </p>
                <span className="font-heading font-bold text-5xl text-pink-dark inline-block" data-id="element-348">
                  $14
                </span>
              </div>

              <div className="max-w-[420px] mb-3" data-id="element-349">
                <CTAButton size="large" onClick={() => {
                if ((window as any).__ctaFired) return;
                (window as any).__ctaFired = true;
                if ((window as any).fbq) {
                  ;
                  (window as any).fbq('track', 'AddToCart', {
                    content_name: 'Bikinis al Crochet Ebook',
                    content_type: 'product',
                    value: 14,
                    currency: 'USD'
                  });
                  (window as any).fbq('track', 'InitiateCheckout', {
                    content_name: 'Bikinis al Crochet Ebook',
                    value: 14,
                    currency: 'USD'
                  });
                }
                setTimeout(() => {
                  window.location.href = 'https://www.yennilemon.com/cart/44201631187079:1?country=US&locale=en-US';
                }, 300);
              }} data-id="element-350">
                  Quiero mi guía + bonos ahora
                </CTAButton>
              </div>

              <p className="font-body text-sm text-medium-gray max-w-[420px]" data-id="element-351">
                Pago seguro por Shopify · Entrega por email (enlace de descarga)
              </p>
            </div>

            {/* ===== DESKTOP RIGHT — CAROUSEL (hidden on mobile) ===== */}
            <div className="hidden md:flex justify-center" data-id="element-352">
              <HeroCarousel className="w-full max-w-[480px]" data-id="element-353" />
            </div>

            {/* ===== MOBILE HERO (hidden on desktop) ===== */}
            <div className="md:hidden text-center col-span-1" data-id="element-354">
              {/* Headline */}
              <h1 className="font-heading font-bold text-[1.65rem] leading-[1.2] text-dark-gray mb-2" data-id="element-355">
                Creá tu propio bikini al crochet en 24 horas
              </h1>
              <p className="font-heading font-bold text-lg text-pink-dark mb-6" data-id="element-356">
                (aunque nunca hayas tejido antes)
              </p>

              {/* Carousel */}
              <div className="mb-7" data-id="element-357">
                <HeroCarousel className="w-[280px] mx-auto" data-id="element-358" />
              </div>

              {/* Bullets */}
              <div className="flex flex-col items-start gap-2.5 max-w-[280px] mx-auto mb-7 text-left" data-id="element-359">
                {['Guía paso a paso desde cero', 'Patrones fáciles y claros', 'Acceso inmediato por email'].map(text => <div key={text} className="flex items-center gap-2" data-id="element-360">
                    <CheckCircleIcon className="w-4 h-4 text-pink-dark flex-shrink-0" data-id="element-361" />
                    <span className="font-body text-dark-gray text-sm font-medium" data-id="element-362">
                      {text}
                    </span>
                  </div>)}
                <div className="flex items-center gap-2" data-id="element-363">
                  <SparklesIcon className="w-4 h-4 text-pink-dark flex-shrink-0" data-id="element-364" />
                  <span className="font-body text-dark-gray text-sm font-bold" data-id="element-365">
                    + 5 bonos GRATIS incluidos
                  </span>
                </div>
              </div>

              {/* What you get box */}
              <div className="bg-beige/50 rounded-xl px-4 py-3 max-w-[280px] mx-auto mb-5 text-left" data-id="element-366">
                <p className="font-body text-xs font-semibold text-dark-gray mb-1.5" data-id="element-367">
                  Recibís hoy (por email):
                </p>
                <p className="font-body text-xs text-medium-gray leading-relaxed" data-id="element-368">
                  • Ebook PDF + 5 bonos
                  <br data-id="element-369" />
                  • Enlace de descarga inmediato
                  <br data-id="element-370" />• Garantía 7 días
                </p>
              </div>

              {/* Compact offer line */}
              <div className="mb-5 text-center" data-id="element-371">
                <p className="font-body text-xs text-medium-gray mb-1" data-id="element-372">
                  Ebook <span className="line-through" data-id="element-373">$19,99</span> + Bonos{' '}
                  <span className="line-through" data-id="element-374">$47</span>{' '}
                  <span className="text-pink-dark font-semibold" data-id="element-375">GRATIS</span>
                </p>
                <p className="font-body text-sm text-medium-gray mb-1" data-id="element-376">
                  Total <span className="line-through" data-id="element-377">$66,99</span> —{' '}
                  <span className="font-bold text-dark-gray" data-id="element-378">80% OFF</span>
                </p>
                <span className="font-heading font-bold text-3xl text-pink-dark" data-id="element-379">
                  $14
                </span>
                <span className="text-medium-gray mx-2 text-sm" data-id="element-380">·</span>
                <span className="text-xs text-medium-gray" data-id="element-381">
                  Garantía 7 días
                </span>
              </div>

              {/* CTA */}
              <div className="mb-3" data-id="element-382">
                <CTAButton size="large" onClick={() => {
                if ((window as any).__ctaFired) return;
                (window as any).__ctaFired = true;
                if ((window as any).fbq) {
                  ;
                  (window as any).fbq('track', 'AddToCart', {
                    content_name: 'Bikinis al Crochet Ebook',
                    content_type: 'product',
                    value: 14,
                    currency: 'USD'
                  });
                  (window as any).fbq('track', 'InitiateCheckout', {
                    content_name: 'Bikinis al Crochet Ebook',
                    value: 14,
                    currency: 'USD'
                  });
                }
                setTimeout(() => {
                  window.location.href = 'https://www.yennilemon.com/cart/44201631187079:1?country=US&locale=en-US';
                }, 300);
              }} data-id="element-383">
                  Quiero mi guía + bonos ahora
                </CTAButton>
              </div>

              {/* Microcopy */}
              <p className="font-body text-xs text-medium-gray" data-id="element-384">
                Pago seguro por Shopify · Entrega por email (enlace de descarga)
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}